/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Flex,
  Button,
  CardHeader,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { Edit, Eye } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Input,
} from "@repo/ui";
import { Input as KendoInput } from "@progress/kendo-react-inputs";
import { useGetImage } from "services/image-api";
import {
  useGetUserProfile,
  useUpdateProfile,
  useUploadDocument,
} from "../../services/auth-api";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import FormInput from "../../components/forms/form-Input";
import FormHookDatePicker from "../../components/forms/form-hook-date-picker";

export default function Profile() {
  const [user, setUser] = useState({});
  const [currentTab, setCurrentTab] = useState("personalInformation");
  const [enableEditing, setEnableEditing] = useState(false);
  const [currentSelectedDocument, setCurrentSelectedDocument] = useState(null);
  const [documentType, setDocumentType] = useState("image");

  const navigate = useNavigate();
  const {
    mutate: getProfile,
    data: profileRes,
    isPending: gettingProfile,
    // error: profileError,
    reset: profileReset,
  } = useGetUserProfile();
  const {
    mutate: uploadDocument,
    data: uploadDocumentRes,
    isPending: uploadingDocument,
    // error: profileError,
    reset: uploadReset,
  } = useUploadDocument();
  const {
    mutate: updateProfile,
    data: updateProfileRes,
    isPending: updatingProfile,
    // error: updateProfileError,
    reset: updateProfileReset,
  } = useUpdateProfile();
  useEffect(() => {
    setDocumentType("image");
  }, [currentSelectedDocument]);
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      dateOfBirth: null,
      dateOfJoining: null,
      nationalIdExpiry: null,
      passportExpiry: null,
      drivingLicenseExpiry: null,
    },
  });
  const generalFieldProps = { control, errors };

  useEffect(() => {
    if (profileRes?.data) {
      MakeProfileData();
    }

    if (updateProfileRes) {
      setEnableEditing(false);
      updateProfileReset();
      navigate("/");
    }
    if (uploadDocumentRes) {
      getProfile();
      uploadReset();
      setUser({});
    }
  }, [profileRes, updateProfileRes, uploadDocumentRes]);
  const MakeProfileData = async () => {
    if (profileRes?.data) {
      const _data = { ...profileRes.data };

      const _user = {
        ..._data,
        dateOfJoining: _data.dateOfJoining
          ? new Date(_data.dateOfJoining)
          : null,
        dateOfBirth: _data.dateOfBirth ? new Date(_data.dateOfBirth) : null,
        nationalIdExpiry: _data.nationalIdExpiry
          ? new Date(_data.nationalIdExpiry)
          : null,
        passportExpiry: _data.passportExpiry
          ? new Date(_data.passportExpiry)
          : null,
        drivingLicenseExpiry: _data.drivingLicenseExpiry
          ? new Date(_data.drivingLicenseExpiry)
          : null,
      };
      if (_user.profilePhotoPath) {
        _user.profilePhotoPath = await useGetImage(_user.profilePhotoPath);
      }
      if (_user.drivingLicenseFilePath) {
        _user.drivingLicenseFilePath = await useGetImage(
          _user.drivingLicenseFilePath
        );
      }
      if (_user.nationalIdFilePath) {
        _user.nationalIdFilePath = await useGetImage(_user.nationalIdFilePath);
      }
      if (_user.passportFilePath) {
        _user.passportFilePath = await useGetImage(_user.passportFilePath);
      }
      profileReset();
      setUser({ ..._user });
      reset(_user);
    }
  };
  useEffect(() => {
    getProfile();
  }, []);

  const onSubmit = (data) => {
    updateProfile({ ...data });
  };
  return (
    <>
      {gettingProfile || uploadingDocument || updatingProfile ? (
        <Loader />
      ) : (
        <></>
      )}

      <Dialog
        open={currentSelectedDocument}
        onOpenChange={(e) => {
          if (!e) setCurrentSelectedDocument(null);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="mb-8">
              Upload {currentSelectedDocument?.fileName || ""}
            </DialogTitle>
          </DialogHeader>
          {/* <KdFileUploader fileUploadHandler={onFileUploaded} /> */}
          {currentSelectedDocument?.path ? (
            documentType === "image" ? (
              <img
                src={currentSelectedDocument?.path || ""}
                onError={() => {
                  setDocumentType("pdf");
                }}
                className="w-full h-[200px] object-contain"
                alt=""
              />
            ) : (
              <p className="text-md">Preview not available</p>
            )
          ) : (
            <></>
          )}

          <Input
            type="file"
            accept={
              currentSelectedDocument?.fileName === "Photo"
                ? "image/png"
                : "image/png, image/gif, image/jpeg, application/pdf"
            }
            onChange={(e) => {
              if (e?.target?.files[0]) {
                const _currentSelectedDocument = {
                  ...currentSelectedDocument,
                  path: URL.createObjectURL(e.target.files[0]),
                  newFile: true,
                  fileName: currentSelectedDocument.fileName,
                  file: e.target.files[0],
                };
                setCurrentSelectedDocument(_currentSelectedDocument);
              }
            }}
          />
          <div className="flex flex-row justify-end gap-4">
            {currentSelectedDocument?.path ? (
              <Button
                onClick={async () => {
                  try {
                    const response = await fetch(currentSelectedDocument?.path);

                    if (!response.ok) {
                      throw new Error(
                        `Failed to fetch Video - ${response.statusText}`
                      );
                    }
                    const blob = await response.blob();
                    const objectUrl = URL.createObjectURL(blob);
                    const newElm = document.createElement("a");
                    newElm.href = objectUrl;
                    newElm.setAttribute(
                      "download",
                      `${currentSelectedDocument?.fileName}.${documentType === "image" ? "png" : "pdf"}`
                    );
                    document.body.appendChild(newElm);
                    newElm.click();
                    URL.revokeObjectURL(newElm.href);
                    document.body.removeChild(newElm);
                    setCurrentSelectedDocument(null);
                  } catch {
                    () => {
                      //empty
                    };
                  }
                }}
                disabled={!currentSelectedDocument?.path}
              >
                Download
              </Button>
            ) : (
              <></>
            )}

            <Button
              onClick={() => {
                uploadDocument({
                  fileName: currentSelectedDocument.fileName,
                  file: currentSelectedDocument.file,
                });
                setCurrentSelectedDocument(null);
              }}
              disabled={!currentSelectedDocument?.file}
            >
              Upload
            </Button>
            <Button
              onClick={() => {
                setCurrentSelectedDocument(null);
              }}
            >
              Cancel
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <div className="form-container">
        <BreadCrumb links={[{ text: "Profile", isCurrentPage: true }]} />

        <Flex w="100%" style={{ gap: "4%" }}>
          <Card style={{ width: "26%", minWidth: "26%" }}>
            <CardBody>
              <div className="profile-side-bar-col">
                <div
                  className="tab"
                  onClick={() => {
                    setCurrentTab("personalInformation");
                  }}
                >
                  Personal Information
                </div>
                <div
                  className="tab"
                  onClick={() => {
                    setCurrentTab("employeeInformation");
                  }}
                >
                  Employee Information
                </div>

                <div className="tab">
                  <Link to={Paths.changePassword}>Change Password </Link>
                </div>
              </div>
            </CardBody>
          </Card>
          <Card w="70%">
            <CardHeader>
              {currentTab === "employeeInformation"
                ? "Employee Information"
                : "Personal Information"}
            </CardHeader>
            <CardBody>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <div
                      className="profile-picture"
                      // style={
                      //   user.profilePhotoPath
                      //     ? {
                      //         background: `url(${user.profilePhotoPath}) center center/cover no-repeat`,
                      //       }
                      //     : {}
                      // }
                    >
                      {user.profilePhotoPath ? (
                        <img
                          className="object-cover absolute top-0 left-0 index z-[1] w-full h-full rounded-[8px]"
                          src={user.profilePhotoPath}
                          alt=""
                        />
                      ) : (
                        <></>
                      )}

                      <Edit
                        className="edit-profile-picture cursor-pointer"
                        onClick={() => {
                          setCurrentSelectedDocument({
                            fileName: "Photo",
                            path: user.profilePhotoPath,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <Button
                    onClick={() => {
                      if (enableEditing) {
                        reset(user);
                      }
                      setEnableEditing(!enableEditing);
                    }}
                  >
                    {enableEditing ? "Cancel Editing" : "Edit"}
                  </Button>
                  {enableEditing ? (
                    <Button type="submit" style={{ marginLeft: "12px" }}>
                      Update
                    </Button>
                  ) : (
                    <></>
                  )}
                </div>
                {currentTab === "employeeInformation" ? (
                  <>
                    <FormInput
                      {...generalFieldProps}
                      name="employeeId"
                      label="Employee ID"
                      inputProps={{ readOnly: true }}
                    />
                    <FormInput
                      {...generalFieldProps}
                      name="designation"
                      label="Designation"
                      inputProps={{ readOnly: true }}
                    />
                    <FormHookDatePicker
                      {...generalFieldProps}
                      name="dateOfJoining"
                      label="Date of Joining"
                      disabled={!enableEditing}
                      datePickerProps={{
                        placeholder: "Date of Joining",
                      }}
                    />
                  </>
                ) : (
                  <>
                    <FormInput
                      {...generalFieldProps}
                      name="firstName"
                      label="First Name"
                      inputProps={{ readOnly: true }}
                    />
                    <FormInput
                      {...generalFieldProps}
                      name="lastName"
                      label="Last Name"
                      inputProps={{ readOnly: true }}
                    />
                    <FormInput
                      {...generalFieldProps}
                      name="email"
                      label="Email"
                      inputProps={{ readOnly: true }}
                    />
                    <FormInput
                      {...generalFieldProps}
                      name="personalEmail"
                      label="Personal Email"
                      inputProps={{ readOnly: !enableEditing }}
                    />
                    <FormInput
                      {...generalFieldProps}
                      name="mobileNo"
                      label="Mobile No"
                      inputProps={{ readOnly: !enableEditing }}
                    />
                    <FormInput
                      {...generalFieldProps}
                      name="personalMobileNo"
                      label="Personal Mobile No"
                      inputProps={{ readOnly: !enableEditing }}
                    />
                    <FormHookDatePicker
                      {...generalFieldProps}
                      name="dateOfBirth"
                      label="DOB"
                      disabled={!enableEditing}
                      datePickerProps={{
                        placeholder: "Date Of Birth",
                      }}
                    />
                    <FormControl>
                      <FormLabel>National ID</FormLabel>
                      <Controller
                        control={control}
                        name="nationalId"
                        render={({ field }) => (
                          <div className="flex flex-row gap-4">
                            <KendoInput
                              readOnly={!enableEditing}
                              value={field.value || ""}
                              onChange={(e) => {
                                field.onChange(e.value);
                              }}
                            />
                            <Button
                              title="View Document"
                              onClick={() => {
                                setCurrentSelectedDocument({
                                  fileName: "NationalId",
                                  path: user.nationalIdFilePath,
                                });
                              }}
                            >
                              <Eye />
                            </Button>
                          </div>
                        )}
                      />
                    </FormControl>

                    <FormHookDatePicker
                      {...generalFieldProps}
                      name="nationalIdExpiry"
                      label="National ID Expiry"
                      disabled={!enableEditing}
                      datePickerProps={{
                        placeholder: "National ID Expiry",
                      }}
                    />

                    <FormControl>
                      <FormLabel>Passport No</FormLabel>
                      <Controller
                        control={control}
                        name="passportNo"
                        render={({ field }) => (
                          <div className="flex flex-row gap-4">
                            <KendoInput
                              readOnly={!enableEditing}
                              value={field.value || ""}
                              onChange={(e) => {
                                field.onChange(e.value);
                              }}
                            />
                            <Button
                              title="View Document"
                              onClick={() => {
                                setCurrentSelectedDocument({
                                  fileName: "Passport",
                                  path: user.passportFilePath,
                                });
                              }}
                            >
                              <Eye />
                            </Button>
                          </div>
                        )}
                      />
                    </FormControl>

                    <FormHookDatePicker
                      {...generalFieldProps}
                      name="passportExpiry"
                      label="Passport Expiry"
                      disabled={!enableEditing}
                      datePickerProps={{
                        placeholder: "National ID Expiry",
                      }}
                    />

                    <FormControl>
                      <FormLabel>Driving License No</FormLabel>
                      <Controller
                        control={control}
                        name="drivingLicenseNo"
                        render={({ field }) => (
                          <div className="flex flex-row gap-4">
                            <KendoInput
                              readOnly={!enableEditing}
                              value={field.value || ""}
                              onChange={(e) => {
                                field.onChange(e.value);
                              }}
                            />
                            <Button
                              title="View Document"
                              onClick={() => {
                                setCurrentSelectedDocument({
                                  fileName: "License",
                                  path: user.drivingLicenseFilePath,
                                });
                              }}
                            >
                              <Eye />
                            </Button>
                          </div>
                        )}
                      />
                    </FormControl>
                    <FormHookDatePicker
                      {...generalFieldProps}
                      name="drivingLicenseExpiry"
                      label="Driving License Expiry"
                      disabled={!enableEditing}
                      datePickerProps={{
                        placeholder: "Driving License Expiry",
                      }}
                    />
                  </>
                )}
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
